<template>
  <el-dialog :visible.sync="dialog" title="导入Excel"
             :width="getIsMobile?'100%':'60%'"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :before-close="handleClose">
    <el-form ref="uploadInfoRef" v-loading="upLoading" label-width="100px" label-position="right" :rules="rules"
             :model="uploadInfo">
      <div class="marginbottom">为减少上传错误，请下载案件导入模版后按照模版格式要求进行数据填写后再上传!</div>
      <!--      <div class="marginbottom">若对已有案件进行数据更新，请填写内部订单号及需更新的字段项，无需更改的字段项请勿填写，否则数据将被覆盖！</div>-->
      <el-link type="primary" icon="el-icon-download" class="marginbottom">
        <a target="_blank" @click="handleDown">下载导入模板</a>
      </el-link>
      <el-form-item label="价格表">
        <el-select
          ref="selectRef"
          @change="handleChangePrice"
          class="model-select"
          v-model="uploadInfo.price_version"
          filterable
          remote
          popper-append-to-body
          reserve-keyword
          :automatic-dropdown="true"
          :default-first-option="true"
          placeholder="请选择价格表"
          :remote-method="priceRemoteMethod"
          clearable
          :loading="priceLoading">
          <el-option
            v-for="item in priceOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <!--        <el-select placeholder="请选择价格表" clearable v-model="selectedPriceList">-->
        <!--          <el-option v-for="item in priceList" :value="item" :label="item">{{item}}</el-option>-->
        <!--        </el-select>-->
      </el-form-item>
      <el-form-item label="原币价格" prop="price" v-if="type === 'edit'">
        <el-input v-model="uploadInfo.price" placeholder="请输入原币价格"></el-input>
      </el-form-item>
      <el-form-item label="原币种" prop="currency">
        <el-select v-model="uploadInfo.currency" placeholder="请选择原币种" filterable clearable>
          <el-option v-for="(item,index) in allRate" :key="index" :label="item.currency_name"
                     :value="item.currency">
            <span style="float: left">{{ item.currency_name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.rate }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="成本系数">
        <el-input v-model="uploadInfo.cost_coefficient" placeholder="请输入成本系数"/>
      </el-form-item>
      <el-form-item label="销售系数">
        <el-input v-model="uploadInfo.selling_coefficient" placeholder="请输入销售系数"/>
      </el-form-item>
      <el-form-item label="供应商" prop="gongyingshang">
        <el-select
          ref="selectRef"
          @change="handleChange"
          class="model-select"
          v-model="uploadInfo.gongyingshang"
          filterable
          remote
          popper-append-to-body
          reserve-keyword
          :automatic-dropdown="true"
          :default-first-option="true"
          placeholder="请选择供应商"
          :remote-method="remoteMethod"
          clearable
          :loading="loading">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="库存版本" prop="version">
        <el-input v-model="uploadInfo.version" placeholder="请输入库存版本"></el-input>
      </el-form-item>
      <el-form-item label="货期" prop="hq">
        <el-select v-model="uploadInfo.hq" allow-create filterable default-first-option
                   placeholder="请选择货期，或手动输入"
                   clearable>
          <el-option v-for="(item,index) in hqData" :key="index" :value="item" :label="item">
            {{ item }}
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="bz">
        <el-input type="textarea" placeholder="请输入备注" autosize v-model="uploadInfo.bz"/>
      </el-form-item>
      <el-form-item label="文件上传" v-if="type === 'add'">
        <el-upload ref="upload" :multiple="false" :limit="1" accept=".xlsx, .xls" :action="action"
                   drag
                   :data="{...uploadInfo}"
                   :show-file-list="true"
                   :auto-upload="false"
                   :on-change="handleChangeUpload"
                   :on-success="uploadSuc" :on-error="uploadFail" :on-remove="cancelExcel" :before-upload="beforeUpload"
                   :file-list="fileList">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" style="color: red;width: max-content" slot="tip">
            提示：仅允许导入“xls”或“xlsx”格式文件！
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {defineComponent, reactive, ref, watch} from '@vue/composition-api'
import {Message} from 'element-ui'
import request from '@/utils/request'
import useRootSetting from '@/hooks/useRootSetting'


export default defineComponent({
  name: 'Import',
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => {
      },
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {emit}) {
    const {getIsMobile} = useRootSetting()
    const upload = ref(null)
    const uploadInfoRef = ref(null)
    const upLoading = ref(false)
    const fileList = ref([])
    const action = ref(`${process.env.VUE_APP_NONE_API}/overseas_upload_excel.php`)

    const defaultForm = () => ({
      price_version: '',
      currency: '',
      gongyingshang: '',
      version: '',
      hq: '',
      bz: '',
      cost_coefficient: '',
      selling_coefficient: '',
      price:''
    })
    const uploadInfo = reactive(defaultForm())

    const rules = {
      fileId: [{
        required: true,
        message: '请上传文件',
        trigger: 'change'
      }],
    }

    const beforeUpload = (file) => {
      // 仅允许 Excel 文件
      const isExcel =
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";

      if (!isExcel) {
        Message.error("只能上传 Excel 文件 (.xls/.xlsx)");
        return false;
      }

      return true;
    }
    const uploadSuc = (e) => {
      if (e.code == 200) {
        Message.success(e.msg)
        emit('uploadSuccess')
      } else if (e.code == 300) {
        Message.error(e.msg)
      } else if (e.code == 400) {
        fileList.value = []
        Message.error(e.msg)
      }
    }
    const cancelExcel = () => {
      uploadInfo.fileId = ''
    }
    const uploadFail = (e) => {
      console.log('上传失败', e)
    }
    //导入下载模板
    const handleDown = () => {
      import( '@/vendor/Export2Excel').then(excel => {
        const tHeader = ['品牌', '型号', '库存数量', '原币价格']
        const data = [
          ["SKF", 16002, 10, 1000],
        ]; // 示例数据
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '海外库存列表'
        })
      })
    }

    const handleClose = () => {
      emit('close')
    }

    watch(() => props.dialog, (val) => {
      if (val) {
        fileList.value = []
      }
    }, {immediate: true})

    //获取价格表
    const priceList = ref([])
    const selectedPriceList = ref('')
    const priceOptions = ref([])
    const priceLoading = ref(false)
    const priceRemoteMethod = async (query) => {
      if (!query) {
        options.value = []
        return
      }
      loading.value = true
      try {
        const {data} = await request({
          url: 'price_version_list.yy',
          method: 'post',
          params: {price_version: query}
        })
        priceOptions.value = data.map(item => ({
          label: item,
          value: item
        }))
      } catch (error) {
        console.error('搜索失败', error)
      } finally {
        loading.value = false
      }
    }
    const handleChangePrice = (name) => {
      uploadInfo.price_version = name
    }

    const hqData = ref([])
    //获取供应商
    const options = ref([])
    const loading = ref(false)
    const remoteMethod = async (query) => {
      if (!query) {
        options.value = []
        return
      }
      loading.value = true
      try {
        const {namelist} = await request({
          url: 'overseas_gys_list.yy',
          method: 'post',
          params: {gongyingshang: query}
        })
        options.value = namelist.map(item => ({
          label: item,
          value: item
        }))
      } catch (error) {
        console.error('搜索失败', error)
      } finally {
        loading.value = false
      }
    }
    //模糊下拉供应商选中请求接口
    const handleChange = (name) => {
      uploadInfo.gongyingshang = name
    }
    // //计算成本价 =  原币价格/币种汇率 * 成本系数
    // watch(
    //   () => [uploadInfo.price, uploadInfo.currency, uploadInfo.cost_coefficient, uploadInfo.rate],
    //   () => {
    //     if (!allRate.value.length) return
    //     let convertedPrice;
    //     // 计算原币种价格转换为人民币
    //     const foundItem = allRate.value.find(item => item.currency === uploadInfo.currency)
    //     convertedPrice = (Number(uploadInfo.price) / (foundItem && Number(foundItem.rate))).toFixed(2)
    //
    //     // 更新最终成本
    //     if (!uploadInfo.price || !uploadInfo.currency || !uploadInfo.cost_coefficient) {
    //       uploadInfo.cost_price = ''
    //       return
    //     }
    //     uploadInfo.cost_price = (convertedPrice * Number(uploadInfo.cost_coefficient)).toFixed(2).toString();
    //   }
    // )
    // //计算销售价格 = 成本价 * 销售系数
    // watch(
    //   () => [uploadInfo.cost_price, uploadInfo.selling_coefficient],
    //   () => {
    //     if (!uploadInfo.cost_price || !uploadInfo.selling_coefficient) {
    //       uploadInfo.selling_price = ''
    //       return
    //     }
    //     uploadInfo.selling_price = (Number(uploadInfo.cost_price) * Number(uploadInfo.selling_coefficient)).toFixed(2).toString();
    //   }
    // )

    //获取货期
    const getDeliveryDate = () => {
      request({
        url: 'delivery_date_list.yy',
        method: 'post',
      }).then((response) => {
        if (response.code == 200) {
          hqData.value = response.data
        }
      })
    }
    //获取汇率
    const getRate = () => {
      const url = `${process.env.VUE_APP_CONTROLLER_API}/exchange_rate.yy.php`
      return request({
        url: url,
        method: 'get'
      })
    }

    const allRate = ref([])

    watch(() => props.dialog, async (dialog) => {
      if (dialog) {
        const {data} = await getRate()
        allRate.value = data
        getDeliveryDate()
      }
    }, {immediate: true})

    watch(() => props.formData, (val) => {
      if (!val || typeof val !== 'object') return;
      Object.keys(val).forEach((key) => {
        if (key in uploadInfo) {
          const value = val[key];

          // 判断 value 是否为字符串形式的纯数字
          uploadInfo[key] = typeof value === 'string' && value !== '' && !isNaN(value)
            ? Number(value)
            : value;

        }
      });
    }, {deep: true})

    const handleReset = () => {
      Object.assign(uploadInfo, defaultForm())
    }

    const handleSubmit = () => {
      if(props.type === 'add'){
        upload.value.submit()
      }else{
        emit('submit', uploadInfo)
      }
      // uploadInfoRef.value.validate(valid => {
      //   if (valid) {
      //     emit('submit', uploadInfo)
      //   }
      // })
    }

    watch(()=>props.type,(type)=>{
      if(type === 'add') {
        handleReset()
      }
    })

    // 收集文件列表
    const handleChangeUpload = (file, rawFileList) => {
      fileList.value = rawFileList
      console.log(fileList.value)
    }
    return {
      priceOptions,
      priceLoading,
      allRate,
      hqData,
      options,
      loading,
      selectedPriceList,
      priceList,
      action,
      fileList,
      getIsMobile,
      upLoading,
      uploadInfoRef,
      upload,
      uploadInfo,
      rules,
      handleChangeUpload,
      handleReset,
      handleSubmit,
      priceRemoteMethod,
      handleChangePrice,
      handleClose,
      remoteMethod,
      handleChange,
      beforeUpload,
      handleDown,
      uploadSuc,
      uploadFail,
      cancelExcel
    }
  }
})
</script>
<style lang="scss" scoped>
.marginbottom {
  margin-bottom: 12px;
}
::v-deep .el-upload {
  width: 100%!important;
  .el-upload-dragger {
    width: 100%!important;
  }
}
</style>
